import { HelmetProvider, Helmet } from "react-helmet-async";

interface PageMetaProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
}

const PageMeta = ({
  title,
  description,
  image,
  url,
}: PageMetaProps) => {
  // URL atual da página se não for fornecida
  const currentUrl = url || window.location.href;
  
  // Imagem padrão caso não seja fornecida
  const defaultImage = "https://sellyo-s3.nyc3.digitaloceanspaces.com/sellyo/Capa.png";
  const ogImage = image || defaultImage;

  // Garantir que a imagem seja HTTPS (obrigatório para WhatsApp)
  const secureImage = ogImage.startsWith('http:') ? ogImage.replace('http:', 'https:') : ogImage;

  return (
    <Helmet>
      {/* Meta tags básicas */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Favicon da Sellyo */}
      <link rel="icon" type="image/png" href="https://sellyo-s3.nyc3.digitaloceanspaces.com/sellyo/sicon.png" />
      <link rel="shortcut icon" type="image/png" href="https://sellyo-s3.nyc3.digitaloceanspaces.com/sellyo/sicon.png" />
      <link rel="apple-touch-icon" href="https://sellyo-s3.nyc3.digitaloceanspaces.com/sellyo/sicon.png" />
      
      {/* Open Graph - Facebook, WhatsApp, LinkedIn */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Sellyo" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={secureImage} />
      <meta property="og:image:secure_url" content={secureImage} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:locale" content="pt_BR" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@sellyo" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={secureImage} />
      <meta name="twitter:image:alt" content={title} />
      
      {/* WhatsApp específico - força cache refresh */}
      <meta property="og:updated_time" content={new Date().toISOString()} />
      
      {/* Meta tags adicionais para melhor SEO */}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};

export const AppWrapper = ({ children }: { children: React.ReactNode }) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default PageMeta;
